import {
  ShopOutlined,
  CoffeeOutlined,
  CloudOutlined,
  BarChartOutlined,
  BoxPlotOutlined,
  LockOutlined,
  DashboardOutlined,
  ThunderboltOutlined,
  SafetyOutlined,
  PrinterOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import logoWhite from '../assets/images/logo/logo-white.png'
import logoBlack from '../assets/images/logo/logo-black.svg'
export const image = {
  logo: logoWhite,
  logoBlack: logoBlack

}

export const heroContent = {
  title: "Transform Your Business with Modern POS Solutions",
  subtitle: "Elevate your operations with our cutting-edge point of sale systems designed specifically for retail and restaurant businesses.",
  buttonText: "Discover More",
  gradient: "from-indigo-600 via-indigo-400 to-indigo-500",
};

export const solutionsContent = {
  title: "Powerful POS Solutions",
  subtitle: "Choose the perfect solution tailored to your business needs",
  solutions: [
    {
      icon: ShopOutlined,
      iconBg: "bg-gradient-to-tr from-emerald-400 to-cyan-400",
      title: "Smart Retail POS",
      key: "pos-solutions",
      description: "Next-generation point of sale system built for modern retail businesses.",
      features: [
        "AI-powered inventory forecasting",
        "Seamless omnichannel integration",
        "Advanced customer analytics",
        "Smart loyalty programs",
        "Automated reordering system",
        "Real-time sales insights"
      ],
      cardBg: "bg-white/80 backdrop-blur-md border border-cyan-200 shadow-xl",
      btnUrl: "/hospitality"
    },
    {
      icon: CoffeeOutlined,
      iconBg: "bg-gradient-to-tr from-orange-400 to-pink-400",
      title: "Restaurant Suite",
      key: "restaurant-suite",
      description: "Complete restaurant management system for exceptional dining experiences.",
      features: [
        "Smart table management",
        "Digital menu boards",
        "Kitchen display integration",
        "Mobile ordering capabilities",
        "Reservation management",
        "Food cost analytics"
      ],
      cardBg: "bg-white/80 backdrop-blur-md border border-pink-200 shadow-xl",
      btnUrl: "/retail"
    }
  ]
};

export const featuresContent = {
  title: "Revolutionary Features",
  subtitle: "Experience the next generation of POS technology",
  features: [
    {
      icon: BoxPlotOutlined,
      title: "Hardware Freedom",
      description: "Run on any device - from tablets to desktops",
      gradient: "from-purple-400 to-indigo-400",
    },
    {
      icon: CloudOutlined,
      title: "Cloud-First Architecture",
      description: "Access your data anywhere with offline support",
      gradient: "from-blue-400 to-cyan-400",
    },
    {
      icon: BarChartOutlined,
      title: "Advanced Analytics",
      description: "AI-powered insights for better decisions",
      gradient: "from-green-400 to-emerald-400",
    },
    {
      icon: LockOutlined,
      title: "Enterprise Security",
      description: "Bank-grade security for your data",
      gradient: "from-red-400 to-pink-400",
    },
    {
      icon: DashboardOutlined,
      title: "Smart Dashboard",
      description: "Customizable views for every role",
      gradient: "from-yellow-400 to-orange-400",
    },
    {
      icon: ThunderboltOutlined,
      title: "Lightning Fast",
      description: "Optimized performance for busy hours",
      gradient: "from-teal-400 to-cyan-400",
    },
    {
      icon: SafetyOutlined,
      title: "PCI DSS Compliant",
      description: "Industry-standard security for all your transactions.",
      gradient: "from-pink-400 to-red-400",
    },
    {
      icon: PrinterOutlined,
      title: "Seamless Printing",
      description: "Effortlessly print receipts, orders, and reports.",
      gradient: "from-yellow-400 to-lime-400",
    },
    {
      icon: TeamOutlined,
      title: "Multi-User Access",
      description: "Role-based permissions for your entire team.",
      gradient: "from-indigo-400 to-blue-400",
    },
    {
      icon: ThunderboltOutlined,
      title: "Instant Setup",
      description: "Get started in minutes with zero technical hassle.",
      gradient: "from-orange-400 to-yellow-400",
    },
    {
      icon: CloudOutlined,
      title: "Automatic Backups",
      description: "Your data is always safe and recoverable.",
      gradient: "from-cyan-400 to-blue-400",
    },
  ]
};

export const teamContent = {
  title: "Meet Our Visionaries",
  subtitle: "The minds behind your success story",
  members: [
    {
      name: "Jugal Kalariya",
      role: "Co- Founder",
      gradient: "from-blue-400 to-indigo-400",
    },
    {
      name: "Dev Biswal",
      role: "Co- Founder",
      gradient: "from-purple-400 to-pink-400",
    },

  ]
};

export const testimonialContent = {
  title: "Success Stories",
  subtitle: "Join hundreds of satisfied businesses",
  testimonials: [
    {
      rating: 5,
      quote: "Transformed our multi-store operations completely. The analytics are incredible!",
      author: "Michael Chen",
      company: "Urban Retail Group",
      gradient: "from-purple-400 to-pink-400",
    },
    {
      rating: 5,
      quote: "Finally, a POS that understands restaurant workflows. Simply outstanding!",
      author: "Isabella Martinez",
      company: "Fusion Restaurants Inc.",
      gradient: "from-blue-400 to-indigo-400",
    },
    {
      rating: 5,
      quote: "The customer support and feature updates keep getting better and better.",
      author: "David Wilson",
      company: "Metro Marketplace",
      gradient: "from-green-400 to-teal-400",
    }
  ]
};

export const ctaContent = {
  title: "Ready to Revolutionize Your Business?",
  subtitle: "Join the future of point-of-sale systems",
  buttons: [
    {
      text: "Get Restaurant Demo",
      gradient: "from-purple-500 to-indigo-500",
    },
    {
      text: "Get Retail Demo",
      gradient: "from-pink-500 to-rose-500",
    }
  ]
};

export const aboutContent = {
  hero: {
    title: "About Our Retail Management Solution",
    subtitle: "Transforming retail businesses with innovative management solutions designed for growth and efficiency.",
    bgColor: "bg-[#51dcb1]"
  },

  ourStory: {
    title: "Our Story",
    content: [
      "SnapPOS was founded with one simple goal: to empower small and medium-sized businesses with powerful, affordable, and flexible point-of-sale technology. Our team has worked extensively across hospitality, retail, and analytics, and we've experienced firsthand how traditional POS systems are often overpriced, locked to proprietary hardware, and lacking in real insights.",
      "We built SnapPOS to break those barriers.",
      "But SnapPOS is more than just a POS system — it's your profit partner.",
      "✅ We help reduce technology costs by removing the need for expensive or locked hardware.",
      "✅ We streamline operations to lower operational costs.",
      "✅ We provide actionable business analytics, backed by real-world expertise in hospitality cost control.",
      "Our mission is to make a difference to your bottom line. We're with your business to make you profit — not just us. At SnapPOS, we believe technology should work for your business – not against your budget."
    ]
  },

  whatAreYouUsing: {
    title: "What Are You Using?",
    features: [
      {
        icon: "inventory",
        title: "Inventory Management",
        description: "Real-time tracking, automated reordering, and comprehensive stock reports to keep your inventory optimized."
      },
      {
        icon: "pos",
        title: "POS System",
        description: "User-friendly checkout experience with multi-payment options, discount management, and receipt customization."
      },
      {
        icon: "analytics",
        title: "Analytics Dashboard",
        description: "Comprehensive reports and visualizations for sales trends, customer behavior, and business performance."
      }
    ]
  },

  futureGoals: {
    title: "Future Goals",
    shortTerm: {
      title: "🔗 Short-Term Goals (2025):",
      goals: [
        { icon: "β", text: "Launch public beta of SnapPOS" },
        { icon: "🔗", text: "Add integrations for takeaway and delivery platforms" },
        { icon: "📚", text: "Expand onboarding and help resources" },
        { icon: "📊", text: "Roll out cost-control dashboards and profit analytics tools" },
        { icon: "💰", text: "Begin offering subscription-based pricing, including a free tier for micro businesses" }
      ]
    },
    longTerm: {
      title: "🌍 Long-Term Goals(2026+)",
      goals: [
        {
          icon: "accounting",
          title: "Integrate with accounting platforms",
          description: "(e.g., Xero, QuickBooks)"
        },
        {
          icon: "mobile",
          title: "Launch mobile apps",
          description: "for Android and iOS"
        },
        {
          icon: "ai",
          title: "Develop an AI-powered profitability assistant",
          description: "for smarter decision-making"
        },
        {
          icon: "hardware",
          title: "Partner with refurbished hardware providers",
          description: "to support sustainable tech use"
        },
        {
          icon: "global",
          title: "Expand to international markets",
          description: ", starting with Europe and South Asia"
        }
      ]
    }
  },

  demo: {
    title: "See Our Solution in Action",
    subtitle: "Interactive Demo",
    description: "Experience the power and simplicity of our retail management solution with our interactive demo. See firsthand how our features can transform your business operations.",
    buttonText: "Start Demo",
    buttonLink: "https://restro.snapposs.com/signup"
  },

  milestones: {
    title: "Milestones",
    subtitle: "Our journey from concept to reality - building the future of point-of-sale technology",
    timeline: [
      {
        year: "✅ 2023",
        phase: "Conceptualization",
        description: "Conceptualized SnapPOS after identifying inefficiencies in existing POS systems. Recognized the need for affordable, flexible, and powerful solutions for SMEs.",
        status: "completed"
      },
      {
        year: "✅ Early 2024",
        phase: "Development Started",
        description: "Development began with a focus on core features: billing, inventory management, multi-device support, and offline mode capabilities to ensure reliability.",
        status: "completed"
      },
      {
        year: "✅ Mid 2024",
        phase: "MVP Completed",
        description: "Completed our MVP and conducted extensive testing in hospitality environments including restaurants and cafés, gathering valuable user feedback.",
        status: "completed"
      },
      {
        year: "✅ Late 2024",
        phase: "Business Formation",
        description: "Registered JK Business Analytics Ltd to support SnapPOS and future SME-focused solutions, establishing a solid legal foundation for growth.",
        status: "completed"
      },
      {
        year: "✅ 2025",
        phase: "Current Phase",
        description: "Preparing for public beta launch and integration of advanced analytics tools. Focus on user onboarding, performance optimization, and market readiness.",
        status: "current"
      }
    ],
    cta: {
      title: "Join Our Journey",
      subtitle: "Be part of the next milestone in retail technology innovation",
      buttonText: "Get Early Access",
      buttonLink: "./contact.html"
    }
  }
};

export const hospitalityScreens = [
  {
    src: require('../assets/images/RestaurentPicture/Dashboard.png'),
    alt: 'Dashboard',
    caption: 'Dashboard Overview',
    subtitle: 'Get a bird’s-eye view of your entire operation.',
    features: [
      'Real-time occupancy and revenue stats',
      'Quick access to key performance indicators',
      'Customizable widgets for your needs',
    ],
  },
  {
    src: require('../assets/images/RestaurentPicture/TableManagement.png'),
    alt: 'Table Management',
    caption: 'Table Management',
    subtitle: 'Seamlessly manage reservations and seating.',
    features: [
      'Drag-and-drop table assignments',
      'Reservation and waitlist integration',
      'Instant guest notifications',
    ],
  },
  {
    src: require('../assets/images/RestaurentPicture/Orders.png'),
    alt: 'Order Tracking',
    caption: 'Order Tracking',
    subtitle: 'Track every order from kitchen to table.',
    features: [
      'Live order status updates',
      'Integrated with POS and kitchen display',
      'Reduce errors and improve speed',
    ],
  },
  // Add more as needed
];

export const hospitalityFeatureCards = [
  {
    title: "QR Code Menu",
    description: "Let customers scan and view your menu on their phones—safe and easy.",
    icon: "QrCodeIcon",
  },
  {
    title: "Payment Gateway Integration",
    description: "Accept UPI, cards, and wallets for quick and secure payments.",
    icon: "CreditCardIcon",
  },
  {
    title: "Custom Floor Plans",
    description: "Create your restaurant’s table layout for better table tracking.",
    icon: "Squares2X2Icon",
  },
  {
    title: "POS (Point of Sale)",
    description: "Fast and easy billing for dine-in, takeaway, and delivery.",
    icon: "DeviceTabletIcon",
  },
  {
    title: "Kitchen Order Tickets (KOT)",
    description: "Send orders directly to the kitchen—no delays or confusion.",
    icon: "TicketIcon",
  },
  {
    title: "Bill Printing",
    description: "Print clear, customizable bills with tax and discount details.",
    icon: "PrinterIcon",
  },
  {
    title: "Staff Management",
    description: "Add staff, assign roles, and track their performance.",
    icon: "UserGroupIcon",
  },
  {
    title: "Multi-Outlet Management",
    description: "Manage all your branches from one place.",
    icon: "BuildingStorefrontIcon",
  },
  {
    title: "Reports",
    description: "View daily sales, stock, and staff reports in one click.",
    icon: "ChartBarIcon",
  },
  {
    title: "Multi-Kitchen Routing & KOT Printing",
    description: "Assign specific menu items to different kitchen sections. Individual KOTs for each kitchen.",
    icon: "ArrowPathIcon",
  },
  {
    title: "Role-Based Access Control",
    description: "Give staff access only to what they need—nothing more.",
    icon: "LockClosedIcon",
  },
  {
    title: "Real-Time Inventory Management",
    description: "Track stock levels live and get alerts when items run low.",
    icon: "CubeTransparentIcon",
  },
];

export const hospitalityPricingPlans = [
  {
    name: 'Starter',
    priceMonthly: 20,
    priceAnnually: 200,
    priceMonthlyINR: 249,
    priceAnnuallyINR: 2499,
    highlight: false,
    button: 'Purchase Now',
    type: "purchase",
    features: [
      "Unlimited access to all core features",
      "Works seamlessly across your branch",
      "No hidden fees or upgrade traps",
      "Always updated with the latest improvements",
      "Simple, transparent pricing – one plan fits all",
    ],
  },
  {
    name: 'Direct Printing App',
    priceMonthly: null,

    highlight: false,
    button: 'Download For Windows',
    button2: 'Download For Mac',
    features: [
      'The Direct Printing App is included with the package and can be installed by the customer at no additional cost.',
      'Self-Installation: Customers may install the app independently without any installation charges.',
      "Assisted Installation: Professional setup support is available on request and will be quoted based on requirements"
    ],
  },
];

export const privacyPolicyContent = {
  title: "Privacy Policy",
  intro: "Your privacy is important to us. This policy outlines how we collect, use, and protect your information while using our restaurant management software.",
  sections: [
    {
      title: "Introduction",
      content: [
        "Welcome to our Privacy Policy. This document explains how we collect, use, and disclose your personal and business information when you use our restaurant software or visit our website.",
        "By accessing or using our services, including our POS system, reservation tools, or customer app, you agree to the collection and use of information in accordance with this policy."
      ]
    },
    {
      title: "Information We Collect",
      list: [
        { label: "Business Information:", value: "Restaurant name, address, business registration info" },
        { label: "Personal Data:", value: "Staff names, emails, contact details, customer reservation info" },
        { label: "Usage Data:", value: "Order logs, sales reports, table bookings, login activity" },
        { label: "Device Information:", value: "IP address, browser type, operating system" },
        { label: "Cookies & Tracking:", value: "For session management and analytics" }
      ]
    },
    {
      title: "How We Use Your Information",
      list: [
        "To manage orders, menus, and inventory",
        "To provide customer reservation and feedback tools",
        "To send notifications about system updates or offers",
        "To generate reports on restaurant performance",
        "To provide technical support and resolve issues",
        "To enhance security and prevent fraud"
      ]
    },
    {
      title: "Data Security",
      content: [
        "We take your data security seriously. Our systems use encryption and secure protocols to protect your data. However, no online platform is completely immune to risks, so we recommend following best practices for securing your own credentials."
      ]
    },
    {
      title: "Third-Party Integrations",
      content: [
        "Our software may integrate with third-party services like payment gateways (e.g., Stripe), delivery partners (e.g., Uber Eats), or marketing tools. These services have their own privacy policies, and we recommend reviewing them when using such integrations."
      ]
    },
    {
      title: "Your Rights",
      list: [
        "Access or update your business or personal data",
        "Request deletion of customer information",
        "Export reports and analytics data",
        "Request data transfer to another service",
        "Withdraw consent to marketing communications"
      ]
    },
    {
      title: "Policy Updates",
      content: [
        "We may occasionally update this policy. We will notify you through email or app notifications when changes are made. Please review this policy periodically for any updates."
      ]
    },
    {
      title: "Contact Us",
      list: [
        { label: "Email:", value: "info@snapposs.com" },
        { label: "Phone:", value: "+91 63531 17739" },
        { label: "Address:", value: "456 Kitchen Avenue, Food City, FC 45678" }
      ],
      footer: "Effective date: April 21, 2025"
    }
  ]
};

// Retail Screens Example
export const retailScreens = [
  {
    src: require('../assets/images/hero/retailPos.png'),
    alt: 'Retail POS',
    caption: 'Point of Sale',
    subtitle: 'Fast, Reliable Checkout',
    features: [
      'Barcode scanning',
      'Multiple payment methods',
      'Discounts & offers',
    ],
  },
  // ... more screens ... 

  // Add Stock Screen
  {
    src: require('../assets/images/hero/retailStock.png'),
    alt: 'Stock Management',
    caption: 'Stock',
    subtitle: 'Real-Time Inventory Control',
    features: [
      'Track stock levels in real-time',
      'Low stock alerts',
      'Easy stock adjustments',
      'Supplier management',
    ],
  },

  // Add Dashboard Analysis Screen
  {
    src: require('../assets/images/hero/retailanalaysis.png'),
    alt: 'Dashboard Analysis',
    caption: 'Dashboard Analysis',
    subtitle: 'Insightful Business Analytics',
    features: [
      'Sales trends & reports',
      'Top-selling products',
      'Customer insights',
      'Exportable analytics',
    ],
  },
];

// Retail Features Example
export const retailFeatureCards = [
  {
    icon: 'ChartBarIcon',
    title: 'Analytics & Reporting',
    description: 'Make data-driven decisions with detailed reports on sales, inventory, staff performance, and more.',
  },
  {
    icon: 'CubeTransparentIcon',
    title: 'Inventory Management',
    description: 'Track stock levels in real-time, set reorder points, and manage suppliers with our intuitive inventory system.',
  },
  {
    icon: 'Squares2X2Icon',
    title: 'POS System',
    description: 'Process sales quickly with our easy-to-use point of sale system that works on any device, online or offline.',
  },
  {
    icon: 'UserGroupIcon',
    title: 'Customer Management',
    description: 'Build customer loyalty with profiles, purchase history, and personalized marketing campaigns.',
  },
  {
    icon: 'DeviceTabletIcon',
    title: 'Mobile Access',
    description: 'Manage your store from anywhere with full mobile-friendly functionality.',
  },
  {
    icon: 'CreditCardIcon',
    title: 'Multi-payment Options',
    description: 'Accept all payment methods including credit cards, mobile payments, and even cryptocurrencies.',
  },
  {
    icon: 'PrinterIcon',
    title: 'Billing & Invoicing',
    description: 'Easily generate invoices, send receipts, and track payments for better cash flow.',
  },
  {
    icon: 'TicketIcon',
    title: 'Discount & Loyalty Programs',
    description: 'Set up discounts, loyalty rewards, and promotions to attract and retain customers.',
  },
  {
    icon: 'LockClosedIcon',
    title: 'Security & Permissions',
    description: 'Control access for staff and protect your business with secure user roles.',
  },
  {
    icon: 'ArrowPathIcon',
    title: 'Staff Management',
    description: 'Schedule shifts, track performance, and manage permissions with our comprehensive staff tools.',
  },
  {
    icon: 'BuildingStorefrontIcon',
    title: 'Store Management',
    description: 'Manage multiple store locations, transfer stock, and monitor performance across all your outlets from a single dashboard.',
  },
  {
    icon: 'QrCodeIcon',
    title: 'Barcode Billing',
    description: 'Scan and bill products instantly with barcode support for faster checkout and reduced errors.',
  },
];

// Retail Pricing Example
export const retailPricingPlans = [
  {
    name: 'Starter',
    priceMonthly: 20,
    priceAnnually: 200,
    priceMonthlyINR: 249,
    priceAnnuallyINR: 2499,
    highlight: false,
    button: 'Purchase Now',
    type: "purchase",
    features: [
      'Unlimited access to all core features',
      'Works seamlessly across your branch',
      'No hidden fees or upgrade traps',
      'Always updated with the latest improvements',
      'Simple, transparent pricing – one plan fits all',
    ],
  },

  {
    name: 'Direct Printing App',
    priceMonthly: null,
    highlight: false,
    button: 'Download For Windows',
    button2: 'Download For Mac',
    features: [
      'The Direct Printing App is included with the package and can be installed by the customer at no additional cost.',
      'Self-Installation: Customers may install the app independently without any installation charges.',
      "Assisted Installation: Professional setup support is available on request and will be quoted based on requirements"
    ],
  },
];

export const termsOfServiceContent = {
  title: "Terms and Conditions",
  subtitle: "Restaurant Management Software - Legal Agreement",
  intro: `Welcome to our Restaurant Management Software. These Terms and Conditions govern your use of our software application designed for restaurant management, including all features related to inventory management, order processing, staff scheduling, table reservations, customer relationship management, and payment processing.

By accessing or using our services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access or use our software.`,
  toc: [
    "Definitions",
    "License and Software Usage",
    "Subscription and Payments",
    "Data Management and Security",
    "User Responsibilities",
    "Limitations of Liability",
    "Termination",
    "Software Updates and Maintenance",
    "Legal Compliance",
    "Modifications to Terms"
  ],
  sections: [
    {
      title: "1. Definitions",
      content: [
        `"Software" refers to our restaurant management application, including all updates, additions, and modifications.`,
        `"User" refers to the restaurant owner, manager, employee, or any individual authorized to access and use the Software.`,
        `"Customer Data" refers to information about your restaurant customers stored within the Software.`,
        `"Subscription" refers to the paid service allowing access to our Software for a specified period.`
      ]
    },
    {
      title: "2. License and Software Usage",
      content: [
        `We grant you a non-exclusive, non-transferable, revocable license to use our Software for your restaurant management needs, subject to these Terms and Conditions.`,
        `This license does not permit:`,
        [
          "Copying, modifying, or creating derivative works based on our Software",
          "Reverse engineering, decompiling, or attempting to extract the source code",
          "Sublicensing, selling, renting, or leasing the Software to third parties",
          "Using the Software in any manner that violates applicable law",
          "Removing or altering any proprietary notices or branding from the Software"
        ]
      ]
    },
    {
      title: "3. Subscription and Payments",
      content: [
        `Our Software is available on a subscription basis with the following terms:`,
        [
          "Subscription fees are billed monthly or annually, as selected at signup",
          "Fees are non-refundable except as required by law",
          "We reserve the right to modify subscription pricing with 30 days notice",
          "Subscription tiers offer different features and user capacity",
          "Payment processing fees for customer transactions are separate from subscription fees",
          "Failure to pay subscription fees may result in service suspension or termination"
        ]
      ]
    },
    {
      title: "4. Data Management and Security",
      content: [
        `Our Software processes several types of data essential to restaurant operations:`,
        [
          "Customer Data: You retain all rights to customer information collected through our Software. We act as a processor of this data.",
          "Menu and Inventory Data: Information about your menu items, recipes, and inventory is stored securely within our system.",
          "Transaction Data: Our system processes and stores payment and order information in compliance with PCI DSS standards.",
          "Employee Data: Staff schedules, performance metrics, and login credentials are protected with appropriate security measures."
        ],
        `You are responsible for maintaining the confidentiality of your account credentials and ensuring that your staff uses the Software in compliance with applicable data protection laws.`
      ]
    },
    {
      title: "5. User Responsibilities",
      content: [
        `As a user of our Restaurant Management Software, you agree to:`,
        [
          "Provide accurate information during registration and when using the Software",
          "Maintain the security of your account credentials",
          "Train your staff on proper Software usage and security practices",
          "Comply with all applicable laws regarding food safety, hygiene, and restaurant operations",
          "Obtain necessary consents from customers for data collection and processing",
          "Report any Software bugs, vulnerabilities, or security incidents promptly",
          "Maintain your own backup of critical business data"
        ]
      ]
    },
    {
      title: "6. Limitations of Liability",
      content: [
        `While we strive to provide reliable and secure software, we cannot guarantee uninterrupted service or the absence of errors:`,
        [
          'The Software is provided "as is" without warranties of any kind',
          "We are not liable for any indirect, incidental, or consequential damages",
          "Our maximum liability shall not exceed the amount paid by you for the Software in the past 12 months",
          "We are not responsible for food safety, quality, or compliance with health regulations",
          "We do not guarantee that the Software will meet all your business requirements"
        ]
      ]
    },
    {
      title: "7. Termination",
      content: [
        `Either party may terminate this agreement under the following conditions:`,
        [
          "You may cancel your subscription at any time, effective at the end of the current billing cycle",
          "We may terminate your access to the Software if you violate these Terms",
          "Upon termination, you must cease all use of the Software",
          "You may request an export of your data within 30 days of termination",
          "After 60 days post-termination, we may permanently delete your account data"
        ]
      ]
    },
    {
      title: "8. Software Updates and Maintenance",
      content: [
        `To ensure optimal performance and security, our Software undergoes regular updates:`,
        [
          "We provide regular software updates and enhancements at no additional cost",
          "Scheduled maintenance may temporarily impact service availability",
          "We will provide advance notice of significant updates or maintenance windows",
          "Critical security updates may be applied automatically without prior notice",
          "We may discontinue certain features with appropriate notice and alternatives"
        ]
      ]
    },
    {
      title: "9. Legal Compliance",
      content: [
        `Our Software includes features designed to assist with various regulatory requirements, but you remain responsible for:`,
        [
          "Compliance with local food safety and hygiene regulations",
          "Appropriate handling of customer data under applicable privacy laws",
          "Proper tax calculation and reporting for food and beverage sales",
          "Compliance with employment laws regarding staff scheduling and payment",
          "Adherence to payment card industry (PCI) standards when processing payments",
          "Age verification for alcohol or restricted product sales"
        ]
      ]
    },
    {
      title: "10. Modifications to Terms",
      content: [
        `We may modify these Terms and Conditions at any time:`,
        [
          "Changes will be effective upon posting to our website or notification within the Software",
          "Your continued use of the Software constitutes acceptance of modified terms",
          "Substantial changes will be communicated via email or in-app notification",
          "If you disagree with changes, you may terminate your subscription"
        ]
      ]
    },
    {
      title: "Contact Us",
      content: [
        "If you have any questions about these Terms and Conditions, please contact our support team:",
        [
          "Email: info@snapposs.com",
          "Phone: +91 63531 17739",
          "Support Hours: Monday-Friday, 8am-8pm EST"
        ],
        "Effective date: April 21, 2025"
      ]
    }
  ]
}; 